import React, { useEffect, useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
import Select from "react-select";

//local
import "./MyList.css";
import { MyText, MyButton, TextInput } from "../";
import { addCommas, storage, useRequest } from "../../utils";
import { Link } from "react-router-dom";
import Axios from "axios";
// import { apiAddress } from "../../utils";

const itemsTitle = [
  "شماره محصول",
  "نام محصول",
  "پشتیبانی",
  "نام کاربر",
  "تاریخ ثبت",
  "عملیات",
];

const MyListUserProducts = ({
  data,
  token,
  pages,
  setPage,
  page,
  totalDocs,
  set_start_date,
  start_date,
  set_end_date,
  end_date,
  selectedDayRange,
  setSelectedDayRange,
  set_search_text,
  search_text,
  get_users_function,
  products,
  set_products,
  set_support_all,
  support_all,
  support_term,
  set_support_term,
}) => {
  const [
    get_products_error,
    get_products_loading,
    get_products_data,
    get_products_function,
  ] = useRequest({
    method: "get",
    url: "/get_products",
  });

  let [options, set_options] = useState();

  useEffect(() => {
    if (get_products_data) {
      set_options(
        get_products_data.products
          .filter((i) => i.type !== "results" && i.type !== "videos")
          .map((i) => ({
            value: i._id,
            label: i.title,
          }))
      );
    }
  }, [get_products_data]);

  const customStyles = {
    control: (style) => ({
      // none of react-select's styles are passed to <Control />
      ...style,
      width: 300,
    }),
  };

  console.log(products);

  return (
    <>
      <div className="myList">
        <div style={{ width: "100%" }}>
          <div className="myList__header">
            <div className="myList__header--buttons">
              <MyText color="#2d3ab5" size="1.2rem">
                جدول
              </MyText>
            </div>
            <MyText color="black" size="1.2rem">
              تعداد : {addCommas(totalDocs)}
            </MyText>
          </div>
          <div className="myList__header">
            <div className="myList__header--buttons">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "15px",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>انتخاب محصول :</div>
                <Select
                  options={options}
                  styles={customStyles}
                  placeholder="محصولی را انتخاب نمایید"
                  isMulti={true}
                  onChange={(v) => set_products(v.map((i) => i.value))}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>متن جست و جو :</div>
                <input
                  type="text"
                  onChange={(e) => set_search_text(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>تاریخ :</div>
                <DatePicker
                  value={selectedDayRange}
                  onChange={(e) => {
                    console.log(e);
                    const from = e.from;
                    const to = e.to;
                    if (from)
                      set_start_date(
                        moment(
                          String(
                            `${from.year}/${
                              String(from.month).length === 1
                                ? "0" + from.month
                                : from.month
                            }/${
                              String(from.day).length === 1
                                ? "0" + from.day
                                : from.day
                            }`
                          ),
                          "jYYYY/jMM/jDD HH:mm:ss"
                        ).toISOString()
                      );
                    if (to)
                      set_end_date(
                        moment(
                          String(
                            `${to.year}/${
                              String(to.month).length === 1
                                ? "0" + to.month
                                : to.month
                            }/${
                              String(to.day).length === 1
                                ? "0" + to.day
                                : to.day
                            }`
                          ),
                          "jYYYY/jMM/jDD HH:mm:ss"
                        ).toISOString()
                      );
                    setSelectedDayRange(e);
                  }}
                  inputPlaceholder="انتخاب نمایید"
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <select
                  class="custom-select"
                  id="customSelect"
                  value={support_all}
                  onChange={(e) => set_support_all(e.target.value)}
                >
                  <option selected value={null}>
                    پشتیبانی کل ترم
                  </option>

                  <option value={true}>دارد</option>
                  <option value={false}>ندارد</option>
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <select
                  class="custom-select"
                  id="customSelect"
                  value={support_term}
                  onChange={(e) => set_support_term(e.target.value)}
                >
                  <option selected value={null}>
                    پشتیبانی ترم به ترم
                  </option>

                  <option value={true}>دارد</option>
                  <option value={false}>ندارد</option>
                </select>
              </div>
              {/* <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>پرداخت موفق :</div>
                <input type="checkbox" />
              </div> */}
            </div>
            <button
              onClick={() => {
                setPage(1);
                get_users_function().then(() => null);
              }}
              type="button"
              class="btn btn-success "
            >
              جست و جو
            </button>
          </div>
          <button
            onClick={() => {
              storage.load("token").then(async (res) => {
                if (!res) {
                  return Promise.reject();
                }
                Axios({
                  url: "/get_user_products_exel", //your url
                  method: "POST",
                  headers: {
                    "x-auth": res,
                  },
                  data: {
                    start_date,
                    end_date,
                    search_text,
                    products,
                    support_all,
                    support_term,
                  },
                  responseType: "blob", // important
                }).then((response) => {
                  const url = window.URL.createObjectURL(
                    new Blob([response.data])
                  );
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", "products.xlsx"); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                });
              });
            }}
            type="button"
            class="btn btn-success "
          >
            دانلود اکسل
          </button>
        </div>
        <div className="myList__itemsTitle">
          {itemsTitle.map((value) => (
            <div className="myList__itemsTitle--item">
              <MyText color="#50525c" size="1rem">
                {value}
              </MyText>
            </div>
          ))}
        </div>
        <div className="myList__itemsContainer">
          {data.map((item, index) => (
            <div className="myList__items">
              <div className="myList__item">
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {Number(index + 1) * Number(page)}
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {item.product_id.title}
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {item?.support_all_payment
                      ? "پشتیبانی کل ترم"
                      : item?.term_ids?.filter((i) => i.support_payment)
                          .length > 0
                      ? "پشتیبانی ترم به ترم"
                      : "بدون پشتیبانی"}
                  </MyText>
                </div>
                <div className="myList__item" style={{ direction: "ltr" }}>
                  <MyText color="#23242b" size="1rem">
                    {item.user_id?.name} - {item.user_id?.phone_number} -{" "}
                    {item.instagram_id}
                  </MyText>
                </div>
                <div className="myList__item" style={{ direction: "ltr" }}>
                  <MyText color="#23242b" size="1rem">
                    {moment(item.creation_date)
                      .locale("fa")
                      .format("YYYY/MM/DD, h:mm:ss a")}
                  </MyText>
                </div>
                <div className="myList__item">
                  <Link
                    to={{
                      pathname: "/dashboard/userDetails/" + item._id,
                      query: { data: item },
                    }}
                  >
                    <button
                      type="button"
                      class="btn btn-primary round mr-1 mb-1 btn-sm"
                    >
                      جزییات
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="myList__footer">
        <div className="myList__footerPagination">
          {page !== 1 ? (
            <div
              onClick={() => setPage(page - 1)}
              className="myList__footerPagination--item"
            >
              قبلی
              {/* <span className="icon-bell" /> */}
            </div>
          ) : null}
          {pages - 2 <= page + 1 ? (
            <div className="myList__footerPagination--item">
              <MyText marginTop="0.3rem">...</MyText>
            </div>
          ) : null}
          <div
            onClick={() => setPage(page)}
            className="myList__footerPagination--item active"
          >
            <MyText marginTop="0.3rem">{page}</MyText>
          </div>
          {pages === page ? null : (
            <div
              className="myList__footerPagination--item"
              onClick={() => setPage(page + 1)}
            >
              <MyText marginTop="0.3rem">{page + 1}</MyText>
            </div>
          )}

          {pages - 2 <= page + 1 ? null : (
            <div className="myList__footerPagination--item">
              <MyText marginTop="0.3rem">...</MyText>
            </div>
          )}
          {pages - 1 <= page + 1 ? null : (
            <div
              onClick={() => setPage(pages - 1)}
              className="myList__footerPagination--item"
            >
              <MyText marginTop="0.3rem">{pages - 1}</MyText>
            </div>
          )}
          {pages <= page + 1 ? null : (
            <div
              onClick={() => setPage(pages)}
              className="myList__footerPagination--item"
            >
              <MyText marginTop="0.3rem">{pages}</MyText>
            </div>
          )}
          {pages === page ? null : (
            <div
              onClick={() => setPage(page + 1)}
              className="myList__footerPagination--item"
            >
              {/* <span className="icon-bell" /> */}
              بعدی
            </div>
          )}
        </div>
        <div className="myList__footerHelp">
          <div className="myList__footerHelp--item">
            <div className="myList__footerHelp--itemDot" />
            <MyText color="#ffad2b" size="12px">
              نیاز به پیگیری
            </MyText>
          </div>
          <div className="myList__footerHelp--item">
            <div className="myList__footerHelp--itemDot green" />
            <MyText color="#37ac68" size="12px">
              پیگیری شده
            </MyText>
          </div>
        </div>
      </div>
    </>
  );
};

export { MyListUserProducts };
